import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import {
  CurrencyCode,
  frontofficeCurrencyFilter,
  getAccountNumberCurrency
} from "@/models/core/currency";


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyExchangeWillBeAppliedNoticeGroup',
  props: {
  model: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props;



const model = computed(() => props.model)

const twoAccountsSelected = computed(() => {
  return model.value.values.fromAccount && model.value.values.destinationAccount
})

const sourceCurrency = computed(() => {
  return getAccountNumberCurrency(model.value.values.fromAccount)
})

const destinationCurrency = computed(() => {
  return getAccountNumberCurrency(model.value.values.destinationAccount)
})

const differentCurrency = computed(() => {
  return twoAccountsSelected.value
    && sourceCurrency.value && destinationCurrency.value
    && (sourceCurrency.value !== destinationCurrency.value)
})

return { __sfc: true,props, model, twoAccountsSelected, sourceCurrency, destinationCurrency, differentCurrency, PayoutHintPanelFormGroup, frontofficeCurrencyFilter }
}

})